module.exports = __webpack_public_path__ + "static/media/psm2.a1f90c23.png";